<template>
  <div :class="{ 'c-dark-theme': $store.state.darkMode }" class="c-app">
    <CContainer class="d-flex align-items-center min-vh-100">
      <CRow class="w-100 justify-content-center">
        <CCol md="6" class="text-center">
          <CIcon name="cil-compass" size="4xl" class="text-muted mb-3" />
          <h1 class="h4 font-weight-bold">We couldn't find that page</h1>
          <p class="text-muted">The link may be old, or the page may have moved.</p>
          <CButton color="primary" to="/">Go to the dashboard</CButton>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: 'Page404'
}
</script>
